import { lazy } from "react";
import LoginComponent from "../components/auth/Login";
import Signup from "../components/auth/Signup";
import CompanyProfile from "../components/companyprofile/companyprofile";

// Upwork clients routes
const dashboard = lazy(() => import("../components/dashboard/dashboard.js"));
const ClientList = lazy(() => import("../components/client/ClientList"));
const ClientForm = lazy(() => import("../components/client/ClientForm"));
const PendingList = lazy(() => import("../components/pending/PendingList"));
const ClientView = lazy(() => import("../components/client/ClientView"));
const pdfviewer = lazy(() => import("../components/pdfview/pdfviewer"));
const CreateInvoice = lazy(() =>
  import("../components/createinvoice/createinvoice")
);
const userform = lazy(() => import("../components/usermangement/userform"));
const Usermanagement = lazy(() =>
  import("../components/usermangement/Usermanagement")
);
const UploadContractorInvoice = lazy(() =>
  import("../components/contractor management/uploadContractorinvoice")
);
const ClientDetail = lazy(() =>
  import("../components/clientdetails/clientDetials")
);
const otp = lazy(() => import("../components/auth/otp"));
const Forgetpassword = lazy(() => import("../components/auth/Forgetpassword"));
const invoicetemplate = lazy(() =>
  import("../components/Invoice template/invoicetemplate")
);
const ContractorManagement = lazy(() =>
  import("../components/contractor management/contractormanagement")
);
const ContrcatorDetails = lazy(() =>
  import("../components/contractor management/contractordetails")
);
const ContractorForm = lazy(() =>
  import("../components/contractor management/contractorform")
);
const ContractorSalary = lazy(() =>
  import("../components/contractor management/contractorsalary")
);
const SalaryStatus = lazy(() =>
  import("../components/contractor management/salaryStatus")
);
const TaskManager = lazy(() => import("../components/tasks/tasklist"));
const ResetPassword = lazy(() => import("../components/auth/resetpassword"));
const Marketing = lazy(() => import("../components/marketing/Marketing"));
const AccountSettings = lazy(() =>
  import("../components/accountsettings/accountsettings")
);
const employeemanagement = lazy(() =>
  import("../components/employee/employeemanagement")
);
const employeeform = lazy(() => import("../components/employee/employeeform"));
const employeecredentials = lazy(() =>
  import("../components/employee/employeecredentials")
);
const employeesalary = lazy(() =>
  import("../components/employee/employeeSalary")
);
const EmployeeDetails = lazy(() =>
  import("../components/employee/employeedetails")
);
const salaryslip = lazy(() => import("../components/employee/salaryslip"));
const empAttendance = lazy(() =>
  import("../components/employee/empAttendance.js")
);
const EmployeeProfile = lazy(() =>
  import("../components/employee/employeeProfile.js")
);

const Reimbursements = lazy(() =>
  import("../components/requests/Reimbursements.js")
);
const Tickets = lazy(() => import("../components/requests/Tickets.js"));
const ContractorOnboarding = lazy(() =>
  import("../components/contractor management/ContractorOnboarding.js")
);
const manageholidays = lazy(() =>
  import("../components/employee/manageholidays.js")
);

export const publicRoutes = [
  // { path: "/Signup", Component: Signup },
  { path: "/profile", Component: CompanyProfile },
  { path: "/", Component: LoginComponent },
  { path: "/otp", Component: otp },
  { path: "/Forgetpassword", Component: Forgetpassword },
  { path: "/reset-password/:email/:token", Component: ResetPassword },
];
// routes.ts
export const protectedRoutes = [
  // Shared by admin + staff
  {
    path: "/dashboard",
    Component: dashboard,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/client-list",
    Component: ClientList,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/client-form",
    Component: ClientForm,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/client-view",
    Component: ClientView,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/clientDetail",
    Component: ClientDetail,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/pending-list",
    Component: PendingList,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/pdfviewer",
    Component: pdfviewer,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/createinvoice",
    Component: CreateInvoice,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/invoicetemplate",
    Component: invoicetemplate,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/contractormanagement",
    Component: ContractorManagement,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/contractordetails",
    Component: ContrcatorDetails,
    allowedRoles: ["contractor"],
  },
  {
    path: "/contractorform",
    Component: ContractorForm,
    allowedRoles: ["admin", "staff", "contractor"],
  },
  {
    path: "/contractorsalary",
    Component: ContractorSalary,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/contractorinvoice",
    Component: UploadContractorInvoice,
    allowedRoles: ["admin", "staff" , "contractor"],
  },
  {
    path: "/salaryStatus",
    Component: SalaryStatus,
    allowedRoles: ["admin", "staff"],
  },
  
  {
    path: "/tasklist",
    Component: TaskManager,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/employeemanagement",
    Component: employeemanagement,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/employeesalary",
    Component: employeesalary,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/Employeedetails",
    Component: EmployeeDetails,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/salary-slip",
    Component: salaryslip,
    allowedRoles: ["admin", "staff"],
  },
  {
    path: "/employeecredentials",
    Component: employeecredentials,
    allowedRoles: ["admin", "staff"],
  },

  // Admin only
  { path: "/user-list", Component: Usermanagement, allowedRoles: ["admin"] },
  { path: "/user-form", Component: userform, allowedRoles: ["admin"] },
  //  { path: "/Signup", Component: Signup , allowedRoles: ["admin"]},
  // { path: "/profile", Component: CompanyProfile,allowedRoles: ["admin"] },

  // Employee ,Admin , Staff
  {
    path: "/requests",
    Component: Reimbursements,
    allowedRoles: ["admin", "staff", "employee", "contractor"],
  },
  {
    path: "/tickets",
    Component: Tickets,
    allowedRoles: ["admin", "staff", "employee", "contractor"],
  },
  {
    path: "/contractor-onboarding",
    Component: ContractorOnboarding,
    allowedRoles: ["contractor"],
  },
  {
    path: "/employee-form",
    Component: employeeform,
    allowedRoles: ["admin", "staff", "employee"],
  },
  {
    path: "/EmpAttendance",
    Component: empAttendance,
    allowedRoles: ["employee", "admin","staff"],
  },
  {
    path: "/manage-holidays",
    Component: manageholidays,
    allowedRoles: [ "admin","staff"],
  },
  // {
  //   path: "/EmpProfile",
  //   Component: EmployeeProfile,
  //   allowedRoles: ["employee"],
  // },
  {
    path: "/marketing",
    Component: Marketing,
    // the marketing permission is what actually gates this; an employee the
    // admin has granted it to must be able to open the page
    allowedRoles: ["admin", "staff", "employee"],
  },
  {
    path: "/accountsettings",
    Component: AccountSettings,
    allowedRoles: ["admin", "staff", "employee"],
  },
];
